import { isProductionBuildType } from '@/environment-detection'
import { datadogLogs } from '@datadog/browser-logs'

export const logInfoEvent = message => {
  if (isProductionBuildType) datadogLogs.logger.info(message)
}

export const logDebugEvent = message => {
  if (isProductionBuildType) datadogLogs.logger.debug(message)
}

export const logWarnEvent = message => {
  if (isProductionBuildType) datadogLogs.logger.warn(message)
}

export const logErrorEvent = message => {
  if (isProductionBuildType) datadogLogs.logger.error(message)
}
